import { camCase } from "$lib/util/format";

export function getRouteName(route?: string | null, params?: Record<string, string> | null, q?: URLSearchParams) {
	if (!route) return 'Unknown';
	switch (route) {
		case '/(app)': {
			if (q?.has('search')) {
				const vert = q?.get('search_vertical') || 'all';
				return `${camCase(vert)} Search`;
			}
			if (!q?.has('latitude') || !q?.has('longitude')) return 'Address Select';
			const vert = q?.get('vertical') || 'restaurant';
			return `${camCase(vert)} Home`;
		} break;
	
		default:
			// console.log('Unknown route:', route);
			return 'Unknown';
			break;
	}
}
